(() => {
  const init = () => {
    document.querySelectorAll('.coasta-blog-hub').forEach((root) => {
      if (root.dataset.filterReady === 'true') return;
      root.dataset.filterReady = 'true';

      const buttons = [...root.querySelectorAll('[data-blog-filter]')];
      const search = root.querySelector('[data-blog-search]');
      const clear = root.querySelector('[data-blog-search-clear]');
      const items = [...root.querySelectorAll('[data-article-item]')];
      const noResults = root.querySelector('[data-blog-no-results]');
      let activeTag = 'all';

      const normalize = (value) => (value || '').toString().trim().toLowerCase();
      const apply = () => {
        const q = normalize(search?.value);
        let visible = 0;
        items.forEach((item) => {
          const tags = normalize(item.dataset.tags).split('|').map((tag) => tag.trim()).filter(Boolean);
          const haystack = normalize(item.dataset.search);
          const tagMatch = activeTag === 'all' || tags.includes(activeTag);
          const searchMatch = !q || haystack.includes(q);
          const show = tagMatch && searchMatch;
          item.hidden = !show;
          if (show) visible += 1;
        });
        if (noResults) noResults.hidden = items.length === 0 || visible > 0;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activeTag = normalize(button.dataset.blogFilter) || 'all';
          buttons.forEach((candidate) => {
            const selected = candidate === button;
            candidate.classList.toggle('is-active', selected);
            candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          apply();
        });
      });

      search?.addEventListener('input', apply);
      clear?.addEventListener('click', () => {
        if (!search) return;
        if (search.value) {
          search.value = '';
          search.focus();
          apply();
        } else {
          search.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
